module.exports = __webpack_public_path__ + "img/login-image.87a0fdd6.svg";